import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./index.scss";
import footer from "../../../assets/images/footer.png";
import { WhiteIcon } from "../../../assets/icons/WhiteIcon";
import { FacebookIcon } from "../../../assets/icons/FacebookIcon";
import { TwitterIcon } from "../../../assets/icons/TwitterIcon";
import { InstagramIcon } from "../../../assets/icons/InstagramIcon";
import { useNavigate } from "react-router-dom";

const CallToActionFooter = () => {
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/newsletter/subscribe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        alert("Merci pour votre inscription !");
      } else {
        alert(data.message || "Erreur lors de l'inscription");
      }
    } catch (error) {
      alert("Erreur réseau");
    }
  };

  return (
    <div className="cta-footer-section">
      <div className="cta-top">
        <Row className="align-items-center">
          <Col md={6}>
            <h2 className="cta-title">
              Ne manquez plus
              <br />
              nos actualités !
            </h2>
            <p className="cta-text mt-4 mb-4">
              Abonnez-vous à notre newsletter pour recevoir en avant-première
              nos nouveautés, nos offres spéciales et des conseils exclusifs
            </p>
            <Form className="email-form d-flex" onSubmit={handleSubmit}>
              <Form.Control
                type="email"
                name="email"
                placeholder="Email ...."
                className="email-input"
              />
              <Button type="submit" className="email-button">
                Envoyer
              </Button>
            </Form>
          </Col>
          <Col md={6} className="text-center mt-4 mt-md-0">
            <img src={footer} alt="Femme pro" className="img-fluid" />
          </Col>
        </Row>
      </div>

      <div className="cta-footer">
        <div className="cta-container">
          <WhiteIcon />
          <Row className="mt-3">
            <Col md={4} sm={6}>
              <h5 className="footer-title">À propos</h5>
              <ul className="footer-links">
                <li>
                  {" "}
                  Nous accompagnons les entreprises dans leur croissance grâce à
                  des solutions créatives et stratégiques : design, marketing
                  digital, consulting et développement web.
                </li>
              </ul>
            </Col>

            <Col md={4} sm={6}>
              <h5 className="footer-title">Nos services</h5>
              <ul className="footer-links">
                <li
                  onClick={() => {
                    navigate(`/consulting`);
                    window.scrollTo(0, 0);
                  }}
                >
                  Consulting stratégique
                </li>{" "}
                <li
                  onClick={() => {
                    navigate(`/developpement`);
                    window.scrollTo(0, 0);
                  }}
                >
                  Développement web
                </li>{" "}
                <li
                  onClick={() => {
                    navigate(`/design`);
                    window.scrollTo(0, 0);
                  }}
                >
                  Marketing digital
                </li>
                <li
                  onClick={() => {
                    navigate(`/marketing`);
                    window.scrollTo(0, 0);
                  }}
                >
                  Design graphique
                </li>
              </ul>
            </Col>

            <Col md={4} sm={6}>
              <h5 className="footer-title">Contact</h5>
              <ul className="footer-links">
                <li>Email : contact@votreagence.com</li>
                <li>Téléphone : +216 00 000 000</li>
                <li>Adresse : [Votre adresse]</li>
              </ul>
            </Col>
          </Row>
          <div className="footer-bottom mt-4 text-center">
            <p className="mb-1">© 2025 Msit Conseil. Tous droits réservés.</p>
            <div className="social-icons mt-4  d-flex  align-items-center  justify-content-center gap-3">
              <FacebookIcon />
              <TwitterIcon />
              <InstagramIcon />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToActionFooter;
